export default __webpack_public_path__ + "static/illustration-content.url-5a0098ceb9adc5d355ba24349c21ab44.svg";